import RenewalForm from "components/RenewalForm"
import VueComponent from "../vue_component"

export default VueComponent(RenewalForm)
